/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IHistoricoRemessaRepository } from "@/interface/historico-de-remessa-do-cliente";

const historicoRemessaRepository: IHistoricoRemessaRepository = {
  /**
   * Função para buscar histórico de remessas do cliente
   * @param accessToken
   * @param cliente_id
   * @returns Promise<any | null>
   */
  async getAllHistoricoRemessa<T>(
    accessToken: string,
    cliente_id: number,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const historicoRemessas = await Instance.get(
      `remessas/cliente/${cliente_id}/historico?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return historicoRemessas?.data;
  },
};

/**
 * EXPORTS
 */
export { historicoRemessaRepository };
